import { Briefcase, GraduationCap } from "lucide-react"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs"
import { motion } from "framer-motion"
import { CollapsibleTimeline } from "../collapsible-timeline"
import { theme } from "../../theme.js";
import { jobExperience } from "../../data/jobExperience"
import { educationInfo } from "../../data/educationInfo"

const Experience = () => {
  return (
    <section id="experience" className="relative pt-16 pb-12 md:pt-32 md:pb-32 bg-zinc-50 dark:bg-black overflow-hidden body-font">
      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="mb-8 md:mb-12 px-4 md:px-8 text-left"
        >
          <h2 className="text-4xl md:text-7xl font-bold mb-6 heading-font tracking-tighter">
            <span className="text-zinc-900 dark:text-white">JOURNEY</span>
          </h2>
        </motion.div>

        <Tabs defaultValue="job" className="w-full text-left">
          <div className="px-4 md:px-8 mb-8 md:mb-12 flex justify-start">
            <TabsList className="flex inline-flex gap-2 bg-transparent p-0">
              <TabsTrigger 
                value="job" 
                className="rounded-full px-6 py-3 data-[state=active]:bg-black dark:data-[state=active]:bg-white data-[state=active]:text-white dark:data-[state=active]:text-black text-zinc-500 border border-black/10 dark:border-white/10 data-[state=active]:border-transparent transition-all heading-font text-base"
              >
                <Briefcase className="w-4 h-4 mr-2" />
                Experience
              </TabsTrigger>
              <TabsTrigger 
                value="education" 
                className="rounded-full px-6 py-3 data-[state=active]:bg-black dark:data-[state=active]:bg-white data-[state=active]:text-white dark:data-[state=active]:text-black text-zinc-500 border border-black/10 dark:border-white/10 data-[state=active]:border-transparent transition-all heading-font text-base"
              >
                <GraduationCap className="w-4 h-4 mr-2" />
                Education
              </TabsTrigger>
            </TabsList>
          </div>
          
          <TabsContent value="job" className="mt-0">
            <CollapsibleTimeline items={jobExperience} colorTheme={theme} />
          </TabsContent>
          <TabsContent value="education" className="mt-0">
            <CollapsibleTimeline items={educationInfo} colorTheme={theme} />
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
};

export default Experience;
